import { Routes } from '@angular/router';
import { canAccessCoreBasicsGuard } from '@zvoove-market/shared';
import { DownloadCategoryBreadcrumb } from './download-category.breadcrumb';
import { DownloadProductBreadcrumb } from './download-product.breadcrumb';
import { DownloadDetailBreadcrumb } from './downloads/detail/download-detail.breadcrumb';

export const downloadRoutes: Routes = [
  {
    path: 'downloads',
    canActivate: [canAccessCoreBasicsGuard()],
    data: {
      breadcrumb: () => $localize`:@@general.downloads:Downloads`,
    },
    children: [
      {
        path: '',
        loadComponent: () => import('./shell/download-shell.page').then((c) => c.DownloadShellPage),
        children: [
          {
            path: ':productShorthand',
            data: {
              breadcrumb: DownloadProductBreadcrumb,
            },
            children: [
              {
                path: 'category/:categoryId',
                data: {
                  breadcrumb: DownloadCategoryBreadcrumb,
                },
                children: [
                  {
                    path: '',
                    loadComponent: () => import('./downloads/list/download-list.page').then((c) => c.DownloadListPage),
                  },
                  {
                    path: 'download/:downloadId',
                    loadComponent: () => import('./downloads/detail/download-detail.page').then((c) => c.DownloadDetailPage),
                    data: {
                      breadcrumb: DownloadDetailBreadcrumb,
                    },
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
];
